module.exports = __webpack_public_path__ + "img/icon_building_4.4194e622.png";